import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createWebCity } from '../../actions/web-cities';
import { fetchWebCountries } from '../../actions/web-countries';
import { fetchCities } from '../../actions/cities';
import { resetError } from '../../actions/errors';
import WebCityForm from './form';

class WebCityNew extends React.Component {
  componentWillMount() {
    const { getCities, getWebCountries } = this.props;
    getCities();
    getWebCountries();
  }

  render() {
    const {
      cities, createAction, goToList, resetErrorAction, webCountries,
    } = this.props;
    const submit = (body) => {
      resetErrorAction();
      return createAction(body).then((result) => {
        if (result.ok) goToList();
        return result;
      });
    };
    return (
      <WebCityForm
        cities={cities}
        webCountries={webCountries}
        title="New web city"
        submitLabel="Create"
        onSubmit={submit}
        cancel={goToList}
      />
    );
  }
}

WebCityNew.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.object),
  createAction: PropTypes.func.isRequired,
  getCities: PropTypes.func.isRequired,
  getWebCountries: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
  webCountries: PropTypes.arrayOf(PropTypes.object),
};

WebCityNew.defaultProps = { cities: [], webCountries: [] };

const mapStateToProps = ({ cities, webCountries }) => ({
  cities: cities.items,
  webCountries: webCountries.items,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  createAction: body => createWebCity(body),
  getCities: () => fetchCities(),
  getWebCountries: () => fetchWebCountries(),
  goToList: () => push('/web-cities'),
  resetErrorAction: () => resetError(),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCityNew);
